module.exports = __webpack_public_path__ + "img/PLC-2.ffbd1e89.png";